import React from 'react'
import { createFileRoute } from '@tanstack/react-router'

import SettingsIndex from '@/features/settings/SettingsIndex'
import { energyDistributionQuery, mealOfDayDivisionsQuery } from '@/api/mealPlan'
import { mealPartsQuery, recommenderSettingsQuery } from '@/api/settings'

export const Route = createFileRoute('/settings/')({
  loader: async ({ context: { queryClient } }) => {
    const [energyDistribution, mealParts, recommenderSettings, mealDivisions] = await Promise.all([
      queryClient.ensureQueryData(energyDistributionQuery),
      queryClient.ensureQueryData(mealPartsQuery),
      queryClient.ensureQueryData(recommenderSettingsQuery),
      queryClient.ensureQueryData(mealOfDayDivisionsQuery),
    ])

    return { energyDistribution, mealParts, recommenderSettings, mealDivisions }
  },
  component: SettingsComponent,
})

function SettingsComponent() {
  const { energyDistribution, mealParts, recommenderSettings, mealDivisions } =
    Route.useLoaderData()

  return (
    <SettingsIndex
      energyDistribution={energyDistribution}
      mealParts={mealParts}
      recommenderSettings={recommenderSettings}
      mealOfDayDivisions={mealDivisions}
    />
  )
}
